import { render, staticRenderFns } from "./RAMenu.vue?vue&type=template&id=517854c8&scoped=true&"
import script from "./RAMenu.vue?vue&type=script&lang=ts&"
export * from "./RAMenu.vue?vue&type=script&lang=ts&"
import style0 from "./RAMenu.vue?vue&type=style&index=0&id=517854c8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517854c8",
  null
  
)

export default component.exports